//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Alert, Button, Checkbox, Chip, FormControl, FormHelperText, IconButton, InputLabel, ListItemText, MenuItem, Modal as ModalTest, OutlinedInput, Select, Snackbar } from '@mui/material';
//  -- Components ---------------------
import { AddCircleSharp, CheckCircleOutline, Close, CloseOutlined } from '@mui/icons-material';
//  -- Features -----------------------
import { filter, find, get, map , uniq } from 'lodash';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
//  -- Constants ----------------------
import { DownOutlined } from '@ant-design/icons';
import { Button as AntdButton, Col, Dropdown, Input, Modal as ModalDrop, Row , Checkbox as AntCheckBox } from 'antd';
import Loading from 'components/Loading';
import AdminGame from "components/OneGame/AdminGame";
import AllTeachers from "components/OneGame/AllTeachersGame";
import Mygame from "components/OneGame/Mygame";
import { useDispatch } from 'react-redux';
import { useBookmarks } from 'store/bookmark/selectors';
import { handleAutologinOneGame, handleBookContent, handleStartGame, handleSyncBookCategories } from "store/one_game/thunks";
import { AiGeneratedBook, AiGeneratedTopic, ClassicGames, DebateLftIcon, IGameLogo, IGameModalImgDeck, ModernGame, playForFunIcon, playForGradeIcon, studyBlankTemplate } from "utils/assets/images";

import { Drawer } from 'antd';
import { useCanvasAssignmentCategory } from 'store/canvas/selectors';
import { useSocket } from 'store/chat/selectors';
import { handleCheckCurrentGame, handleCreateGameSession } from 'store/game_session/thunks';
import { useOneGameModal } from 'store/one_game/selectors';
import { useSchoologyGradeCategory } from 'store/schoologyauth/selectors';
import { useClassUsers, useUserClasses, useUsersByClass } from 'store/userClasses/selectors';
import { GRADE_TYPE_ALL, GRADE_TYPE_CANVAS } from 'utils/config/reference';
import OneGameUpdated from "../../utils/assets/images/OneGameUpdated.svg";

import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import DemoPreview from 'components/ViewDemoModal';
import moment from 'moment-timezone';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { v4 } from 'uuid';
import { getBookDisplayName, getUnitsPages, isVideo } from 'utils/lib/ebookHelper';
import { useResources, useVideos } from 'store/resources/selectors';
import DraftGame from './DraftGame';
import RenderIfVisible from 'react-render-if-visible';
import { makeStyles } from '@mui/styles';
import { useBookOrder } from 'store/books/selectors';
import sysConfig from "config"
import AIUsageInfo from 'components/Modals/AiInfoModal';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { useUserProfileConfig } from 'store/users/selectors';
import { Badge } from '@mui/material';
import { useLearningModuleCount } from 'store/bingo/selectors';
import SentryWrap from 'components/Sentry';

const GradeConfig = ({ options, value, label, onChange, hasInput, objValue = {}, setError , is_schoology  }) => {
    const label_txt = useMemo(() => {
        const f_value = value ? find(options, k => k.value == value || k.id == value) : null;
        if (f_value) {
            return `${label}(${f_value.title || f_value.type})`
        }
        return label;
    }, [value, options, label])
    const handleMenuClick = (e) => {
        const f_value = find(options, k => k.value == e.key || k.id == e.key)
        if (f_value) {
            if (f_value.value === "points") {
                onChange({ ...f_value, max_point: 100 })
                setError(false);
            } else {
                onChange(f_value)
                setError(false);
            }

        }
    };

    const handleInputChange = (e) => {
        const value = parseInt(e.target.value, 10);
        if (isNaN(value) || value <= 0) {
            setError(true);
        } else {
            setError(false);
            onChange({ ...objValue, max_point: value });
        }
    };

    const menu = {
        items: map(options, pt => ({
            key: pt.id || pt.value,
            label: pt.title || pt.type,
            onClick: () => handleMenuClick({ key: pt.id || pt.value })
        }))
    };
    return (
        <div className='linksSectionIcon text-dark' style={{ flexDirection: "column" }}>
            <Dropdown menu={menu}>
                <div className='linksSectionIcon text-dark'>
                    {value ? (
                        <span>
                            <CheckCircleOutline style={{ color: 'green' }} />
                        </span>
                    ) : (
                        <span>
                            <AddCircleSharp />
                        </span>
                    )}
                    {label_txt}
                </div>
            </Dropdown>
            {hasInput && (value === "points"|| is_schoology) && <Input placeholder="max points" defaultValue={"100"} inputMode="numeric" style={{ borderRadius: 20 }} type="numeric" onChange={handleInputChange} />}
        </div>
    );
};

const ButtonContainers = styled.div`
   display: flex !important;
   align-items:center;
    flex-wrap:wrap;
    gap:11px;
`;

const ModalRowDelete = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 16px;
  width: 100%;
`
const ModalContentDelete = styled.div`
  align-items: center;
  background-color: #112643;
//   display: inline-flex;
  flex-direction: column;
  left: 50%;
  width: 83%;
 padding: 30px 16px 0px 16px;
  position: absolute;
//   text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  @media (max-width: 600px) {
    width: 88%; 
  }
  `
const Text = styled.span`
  color: black;
  font-size: 11px;
  margin-top: 2px;
  text-align: left;
`
const loadingEffect = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;
const AnimatedLink = styled.a`
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100% !important;
    border-radius: 45px;
    text-decoration: none;
    padding: 12px 12px;
    background: transparent;
    transition: background 0.5s ease;
    margin-bottom: 26px;
    box-shadow: -1px 0px 5px 0px rgb(0 0 0 / 28%);
    color:${p => p.isLoading ? "#fff" : "#000000"};
    ${({ isLoading }) => isLoading && css`
    animation: ${loadingEffect} 3s ease infinite;
    background-image: linear-gradient(to right, #3c1661, #fb00e4);
    background-size: 200% 200%;
     `}
    &:hover {
        background-image: linear-gradient(to right, #3c1661, #fb00e4);
        background-size: 200% 200%;
        color: #ffffff;
      }
`;
const CardImg = styled.img`
    height: 70px;
`;
const CardLabel = styled.label`
    display: block;
    margin: 0;
    cursor: pointer;
`;
const CardSpan = styled.span`
    text-align: center;
    display: flex;
    width: 257px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    padding: 0px 14px;
    margin: 0;
    cursor: pointer;
`;

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const CustomFormHelperText = styled(FormHelperText)`
 color:red !important;
  .MuiFormHelperText-root{
  color:red !important;
  }
`

const configServer = import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'prod' : 'dev';

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: '4px',
    },
  }));

//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook
//
//  -- Description
//  Ebook display component
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const OnegameModals = ({
    chapter,
    page,
    currentUser,
    booksAllList,
    currentClass,
    aiModal,
    setAiModal,
    page_1game_ai_content,
    newMaskId,
    resource = false,
    backToLabelStory = false,
    pages = [],
    bookUnits = {},
    book_content = {},
    gameCardId = null,
}) => {
    const videos = useVideos();
    const classes = useStyles();
    const showAlert = useAlert();
    const dispatch = useDispatch();
    const resources = useResources();
    const classBookmark = useBookmarks();
    const userClasses = useUserClasses();
    const usersByClass = useUsersByClass();
    const orgPermissions = useCurrentOrgPermission();
    const learningModuleCount = useLearningModuleCount();
    const isAdmin = get(currentUser, "role") === "owe_admin";

    const { socketConnection, reCreateSocket } = useSocket()
    const [modalVisible, setModalVisible] = useState(false);
    const [currentSection, setCurrentSection] = useState(isAdmin ? 'my_game' : 1);

    const {createCollectionNotification} = useCollectionNotification();
    const classUsers = useClassUsers()

    const [selectedOption, setSelectedOption] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [gradingIsOpen, setGradingIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState(false);

    const [gameVisibleEbk, setgameVisibleEbk] = useState(false);
    const [currentScenarioEbk, setCurrentScenarioEbk] = useState(1);
    const [selected, setSelected] = useState(false);
    const [selectedAdd, setSelectedAdd] = useState(false);
    const inputRef = useRef(null);
    const [redirectLoader, setRedirectLoader] = useState(false);
    const [visible, setVisible] = useState(false);
    const [activeGame, setActiveGame] = useState({});
    const getNumberMask = useCallback((_page) => get(find(get(find(booksAllList, { id: chapter }), "pages"), k => k.pageId == _page), "NumberMasked", _page), [chapter, booksAllList, classBookmark])
    const getBookDataForGame = useMemo(() => find(booksAllList, { id: chapter }), [booksAllList, chapter]);
    const { openOnegameModal } = useOneGameModal()
    const [gameInitLoader, setGameInitLoader] = useState(false);
    const [gameEditLoader, setGameEditLoader] = useState(false);
    const [gameRedirectLoader, setGameRedirectLoader] = useState(false);
    const [alertSakeBar, setAlertSakeBar] = useState({ open: false, message: '', severity: "success" })
    const [gameDuplicateLoader, setGameDuplicateLoader] = useState(false);
    const [, , schoologyAllClassGradeCategory] = useSchoologyGradeCategory()
    const canvasAssignmentCategory = useCanvasAssignmentCategory()
    const [playConfigModal, setPlayConfigModal] = useState(false)
    const [game_config_enable, setPlayConfigEnable] = useState(false)
    const [selectedGame, setSelectedGame] = useState({})
    const [startGameLoading, setStartGameLoading] = useState(false);
    const [game_grade_category, setGameGradeCategory] = useState({});
    const [game_grade_type, setGameGradeType] = useState({});
    const [game_ungraded, setGameUngraded] = useState(false);
    const [modeType, setModeType] = useState('');
    const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
    const isCleverUser = !!(currentUser && currentUser.cleverId);
    const isCanvasUser = !!(currentUser && currentUser.canvas_id);
    const isGoogleUser = !!(currentUser && currentUser.googleId);
    const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
    const [gameTypeSelect, setGameTypeSelect] = useState('all');
    const [createConfigModal, setOpenCreateConfigModal] = useState(false);
    const [config, setConfig] = useState({ pages:'' });
    const [createLoader, setCreateLoader] = useState(false);
    const bookOrder = useBookOrder()
    const {checkPopUpAtOnce, updatePopUpAtOnce} = usePopUpAtOnce();
    const { isAiPermissionEnabled } = useUserProfileConfig();

    const archived_group = useMemo(() => currentClass.archived_group || [], [currentClass])
    const [btnClicked, setBtnClicked] = useState(false);
    const [error, setError] = useState(false);
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
    const currentPage = Number(page);
    // const rangeStart = Math.max(currentPage - 4, 1);
    // const rangeEnd = currentPage + 4;
    const pageLearningModuleCountGames = useMemo(() => {
        // if (resource) {
        //     return learningModuleCount?.games;
        // } else {
        //     return learningModuleCount?.games?.filter(item => (gameCardId && String(item?.page_name) === String(gameCardId)) || (String(item?.page_name) === String(newMaskId))) || {};
        // }
        return learningModuleCount?.games;
    }, [learningModuleCount, newMaskId, gameCardId]);

    const pageLearningModuleCountGamesAdmin = useMemo(() => {
        return learningModuleCount?.adminGames;
    }, [learningModuleCount, newMaskId]);

    const handleForDistrictAdmin = () =>{
      if (currentUser.role === 'admin') {
        showAlert('Please login as teacher!' ,"error")
        return true;
      }
      return false;
    }

    const notifyStudents = (data) => {
        if (socketConnection) {
            try {
                if (socketConnection.readyState == 3) {
                    reCreateSocket()
                    setTimeout(() => {
                        socketConnection.send(JSON.stringify(data))
                    }, 2000)
                } else {
                    socketConnection.send(JSON.stringify(data))
                }
            } catch (error) {
                console.log(error, "error")
            }
        }
    }
    const sendNotifications = async (notificationData) => {
        try {
            const updateNotification = await createCollectionNotification(notificationData, usersByClass);
            const messageCreate = {
                ...updateNotification,
                senderId: get(currentUser, 'id', ''),
                receiverId: '',
                classId: get(currentClass, 'id', ''),
                code: 'system_notification'
            }
            notifyStudents(messageCreate)
        } catch (error) {
            console.log(error, "error")
        }
    }
    const handleCancelEbk = () => {
        setgameVisibleEbk(false);
    };
    const handleNextEbk = () => {
        setCurrentScenarioEbk(currentScenarioEbk + 1);
    };
    const showModalEbk = () => {
        setgameVisibleEbk(true);
        setCurrentScenarioEbk(2);
    };

    const handleMode = (mode_type) => {
        setModeType(mode_type)
        setgameVisibleEbk(true);
        setCurrentScenarioEbk(1);
    }

    const handleCancel = () => {
        setModalVisible(false);
        setAiModal(false);
        setGameTypeSelect('');
        updatePopUpAtOnce(false);
    };

    const showModal = (type) => {
        setModalVisible(true);
        setCurrentSection(type ? type : 1);
    };

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    const onAIPagesClose = () => {
        if (createLoader) return
        setOpenCreateConfigModal(false);
        setConfig({ pages: '' })
    }

    const handleSelectChange = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };
    const handleSelectGrading = (option) => {
        setSelectedOptions(option);
        setGradingIsOpen(false);
    };
    const getBooks = () => {
        const books = [];
        const books_group_permission = get(orgPermissions, "books_group_permission", []);
        (bookOrder || []).forEach((order) => {
            const class_books_group = currentClass.books_group || []
            if (archived_group.includes(order.key)) return null;
            if (books_group_permission.length == 0 || books_group_permission.includes(order.key)) {
                const has_book = find(class_books_group, k => k == order.key);
                if (has_book) {
                    books.push(...order.order);
                }
            }
        })

        // (currentClass.books_group || []).forEach((key) => {
        //     bookOrder.forEach((order) => {
        //         if (order.key === key) {
        //             books.push(...order.order);
        //         }
        //     })
        // })
        return uniq(books);
    }

    const getOrderForHomeGame = () => {
        const books = [];
        const books_group_permission = get(orgPermissions, "books_group_permission", []);
        (bookOrder || []).forEach((order) => {
            const class_books_group = currentClass.books_group || []
            if (archived_group.includes(order.key)) return null;
            if (books_group_permission.length == 0 || books_group_permission.includes(order.key)) {
                const has_book = find(class_books_group, k => k == order.key);
                if (has_book) {
                    books.push({
                        key: order.key,
                        title: order.title,
                        order: order.order
                    })
                }
            }
        })
        return uniq(books);
    }

    const getClassMetadata = () => {
        return ({
            class_id: currentClass?.id,
            class_display_name: currentClass?.displayName,
            books: getBooks(),
            order: getOrderForHomeGame(),
            classes: userClasses.map(({ books, displayName, id }) => ({
                books,
                displayName,
                id,
            }))
        })
    }
    const contentInfo = (data) => {
    //   const bookName = get(getBookDataForGame, "description", "");
      const bookName = getBookDisplayName(booksAllList, chapter, true, videos, resources);
      const end = getNumberMask(data?.end_page || "");
      const start = getNumberMask(data?.start_page || "");
      const pageInfo = start || end ? `${start} - ${end}` : "";
      return `${bookName}${pageInfo ? `  ${pageInfo}` : ""}`;
    };

    const onAIContentPageModal = () => {
        setOpenCreateConfigModal(true)
        setConfig(k => ({ ...k, pages: `${page}` }));
    }
    const onAiContentCreation = async () => {
      try {
        const pages = get(getBookDataForGame, "pages", []);
        const unitsPages = getUnitsPages(page, bookUnits ? bookUnits : [], pages);
        const hasSuperLessonPage = getBookDataForGame?.superLesson
          ? find(getBookDataForGame.superLesson, (p) => {
              const from = Number(p.from);
              const to = Number(p.to);
              const currentPageIndex = pages.findIndex((x) => parseInt(x.pageId, 10) === Number(page));
              const startIndex = pages.findIndex((x) => parseInt(x.pageId, 10) === from);
              const endIndex = pages.findIndex((x) => parseInt(x.pageId, 10) === to);
              return currentPageIndex >= startIndex && currentPageIndex <= endIndex;
            })
          : null;
         
        setBtnClicked(true);
        let content = {
          content: '',
          contentInfo: '',
        };
        if (!page_1game_ai_content) {
          content = {
            content: '',
            contentInfo: contentInfo(page_1game_ai_content),
          };
        } else {
          content = {
            content: '',
            contentInfo: contentInfo(page_1game_ai_content),
          };
        }
        setRedirectLoader(content ? "ai_content" : "ai");
        setCreateLoader(true);
        let allPages = [];
        if(Array.isArray(book_content)&&book_content.length > 0){
          allPages = book_content.map((x) => parseInt(x.pageId, 10)).slice(0,15);
        }
        else if (isAdmin) {
          allPages = config?.pages.split(',').map((p) => parseInt(p.trim(), 10));
        } else if (hasSuperLessonPage) {
          const from = parseInt(hasSuperLessonPage.from, 10);
          const to = parseInt(hasSuperLessonPage.to, 10);
          if(getBookDataForGame?.pages?.length > 0){
            const startIndex = getBookDataForGame?.pages?.findIndex((x) => parseInt(x.pageId, 10) === from);
            const endIndex = getBookDataForGame?.pages?.findIndex((x) => parseInt(x.pageId, 10) === to);
            allPages = getBookDataForGame?.pages?.slice(startIndex, endIndex + 1).map((x) => parseInt(x.pageId, 10));
          }
        } else if (unitsPages.unit?.id) {
          allPages =  unitsPages.pagesInRange.map((x) => parseInt(x.pageId, 10));
        } else {
            allPages = [currentPage];
        }
        const result = await dispatch(handleBookContent({ chapter, page: allPages, resource }));
        const hasAnyContent = resource ? result !== '' : Array.isArray(result) && result.some((item) => Array.isArray(item?.content) && item.content.length > 0);
        if (!hasAnyContent) {
          setRedirectLoader(null);
          setCreateLoader(false);
          return showAlert(
            'This page has no content. Please select a page with content on it',
            'info',
          );
        }
        await handleRedirectOnegame('ai', content, allPages);
        setCreateLoader(false);
        setOpenCreateConfigModal(false);
      } catch (error) {
        console.log(error, 'error');
        showAlert('This page has no content. Please select a page with content on it', 'info');
      } finally {
        setBtnClicked(false);
      }
    };

    const handleAIGenerateFromBookSection = () => {
        if(!isAiPermissionEnabled){
            showAlert('Please enable AI permission to generate content using AI.', 'error');
            return;
        }
        if(btnClicked) return;
        if(isAdmin && !isVideo(chapter, resources)){
            onAIContentPageModal();
        } else {
            onAiContentCreation();
        }
    }

    const handleAIGenerateFromMyOwnTopics = () => {
        if(!isAiPermissionEnabled){
            showAlert('Please enable AI permission to generate content using AI.', 'error');
            return;
        }
       if(btnClicked) return;
       handleRedirectOnegame("ai");
    }

    const user_type = useMemo(() => {
        const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
        const isCleverUser = !!(currentUser && currentUser.cleverId);
        const isCanvasUser = !!(currentUser && currentUser.canvas_id);
        const isGoogleUser = !!(currentUser && currentUser.googleId);
        const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
        if (isSchoologyUser) {
            return 'schoology'
        } else if (isCleverUser) {
            return 'clever'
        }
        else if (isCanvasUser) {
            return 'canvas'
        }
        else if (isClassLinkuser) {
            return 'classlink'
        }
        else if (isGoogleUser) {
            return 'google'
        }
        else {
            return 'owe'
        }
    }, [currentUser])
    const grade_category = useMemo(() => {
        if (currentClass.canvas_id) {
            const grade_cat = canvasAssignmentCategory[currentClass.canvas_id];
            if (Array.isArray(grade_cat)) {
                return grade_cat.map(k => ({
                    id: k.id,
                    title: k.name
                }))
            }
            return []
        } else if (currentClass.sectionId) {
            const grade_cat = schoologyAllClassGradeCategory[currentClass.sectionId];
            if (Array.isArray(grade_cat)) {
                return grade_cat.map(k => ({
                    id: k.id,
                    title: k.title,
                    grade_type: k.calculation_type == 2 ? 'points' : 'percent'
                }))
            }
            return []
        }
        return [];
    }, [currentClass, schoologyAllClassGradeCategory, canvasAssignmentCategory])
    const grade_type = useMemo(() => {
        if (currentClass.canvas_id) {
            return GRADE_TYPE_CANVAS;
        } else {
            return GRADE_TYPE_ALL;
        }
    }, [currentClass]);

    const handleRedirectOnegame = async (templet, content, allPages) => {
        setBtnClicked(true)
        setRedirectLoader(content ? "ai_content" : templet)
        const data = await dispatch(handleAutologinOneGame(currentUser.id,
            currentClass.id,
            {
                pages: (content && isAdmin && config?.pages) ? config.pages.split(',') :  allPages?.length > 0
                ? allPages.map(p => String(p)) : [],
                user_role_admin: isAdmin,
                action: 'create_game',
                templet: templet,
                bookId: chapter,
                page: page,
                pageTitle: getNumberMask(page) || page,
                content,
                categoryImage: getBookDataForGame?.resource,
                categoryTitle: getBookDataForGame?.description,
                class_info: getClassMetadata(),
                game_type: '1game',
                user_type,
                grade_category,
                grade_type,
                game_mode: modeType,
                resource,
                isAiPermissionEnabled
            }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth';
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
            //  window.open(url, '_blank');
        }
        setgameVisibleEbk(false);
        setRedirectLoader(null)
        setBtnClicked(false);
    }

    const onStartGame = async (gameData, play_for) => {
      if (!gameData || gameInitLoader) return; // Prevent multiple clicks while loading

      setGameInitLoader(true);
      try {
        // First check if there's already an active session for this game
        const checkGameResponse = await dispatch(
          handleCheckCurrentGame(currentUser.id, currentClass?.id)
        );
        const existingGame = Array.isArray(checkGameResponse)
          ? checkGameResponse[0]
          : null;

        if (existingGame && existingGame.status !== "ended") {
          // Use existing session
          const data = await dispatch(
            handleAutologinOneGame(currentUser.id, currentClass.id, {
              action:
                existingGame.status === "started"
                  ? "join_play_game"
                  : "join_game",
              role: "teacher",
              session_id: existingGame.session_id,
              game_id: existingGame.game_data?.game_id,
              session_code: existingGame.game_data?.pin_code,
              class_info: getClassMetadata(),
              user_type,
              grade_category,
              grade_type,
              isAiPermissionEnabled
            })
          );

          if (data?.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`;
            if ( sysConfig.is_local ) {
              uri = `http://${window.location.hostname}:3011/session_auth`;
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth';
            }
            const url = `${uri}?key=${data.key}`;
            openOnegameModal(url);
          }
        } else {
          // Create new session only if no active session exists
          const game_start = await dispatch(
            handleStartGame(currentUser.id, gameData.game_id, currentClass.id, {
              grade_category: game_grade_category,
              grade_type: game_grade_type,
              ungraded: game_ungraded,
              play_for,
            })
          );

          if (game_start?.id) {
            const game_data = gameData;
            await dispatch(
              handleCreateGameSession(
                game_start.id,
                currentUser.id,
                currentClass.id,
                game_data,
                {
                  grade_category: game_grade_category,
                  grade_type: game_grade_type,
                  ungraded: game_ungraded,
                  play_for,
                }
              )
            ); // Prepare notification data
            let notifydata = {
              userId: currentUser.id,
              classId: currentClass.id,
              game_data: game_data,
              session_id: game_start.id,
              session_code: game_start.pin_code,
              code: "play_game_notification",
            };

            const notificationData = {
              id: v4(),
              classId: get(currentClass, "id", ""),
              displayName: game_data?.display_name.slice(0, 20) + "...",
              senderId: get(currentUser, "id", ""),
              receiversId: filterClassUsers,
              modified: moment().toISOString(),
              data: notifydata,
              message: `Your teacher started this Game, Please join`,
              type: "play_game_notification",
              userSeen: [],
            };

            // const notificationData = {
            //     classId: get(currentClass, 'id', ''),
            //     displayName: game_data?.display_name.slice(0, 20) + '...',
            //     userId: get(currentUser, 'id', ''),
            //     modified: new Date(),
            //     data: notifydata,
            //     message: `Game is started by your teacher , please join.`,
            //     createdBy: get(currentClass, 'id', ''),
            //     type: 'play_game_notification',
            //     seen: true
            // }
            await Promise.all([
              sendNotifications(notificationData),
              notifyStudents(notifydata),
            ]);

            const data = await dispatch(
              handleAutologinOneGame(currentUser.id, currentClass.id, {
                action: "join_game",
                role: "teacher",
                session_id: game_start.id,
                game_id: game_start.game_id,
                session_code: game_start.pin_code,
                class_info: getClassMetadata(),
                user_type,
                grade_category,
                grade_type,
                isAiPermissionEnabled
              })
            );

            if (data?.key) {
              let uri = `https://1gamestaging.nosotrosonline.com/session_auth`;
              if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`;
              } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth';
              }
              const url = `${uri}?key=${data.key}`;
              openOnegameModal(url);
            } else {
              setAlertSakeBar({
                open: true,
                message:
                  "Something went wrong while opening 1game  please try again.",
                severity: "error",
              });
            }
          } else {
            setAlertSakeBar({
              open: true,
              message: "Something went wrong please try again.",
              severity: "error",
            });
          }
        }
        handleCancel();
        onClose();
        onPlayConfigModalClose();
      } catch (error) {
        console.error("Error in onStartGame:", error);
        setAlertSakeBar({
          open: true,
          message: "An error occurred while starting the game.",
          severity: "error",
        });
      } finally {
        setGameInitLoader(false);
        onPlayConfigModalClose();
        handleCancel();
      }
    };
    const closeAlert = () => {
        setAlertSakeBar({ ...alertSakeBar, open: false, message: '' })
    }
    const handleChange = (value) => {
        if (value == '1') {
            showModal(1);
        }
        else if (value == 'my_game') {
            showModal('my_game')
        }
        else if (value == 'all_teachers') {
            showModal('all_teachers')
        }
        else if (value == 'Game_Homepage') {
            onRedirect1Game();
        }
        else if (value == 'draft_game') {
            showModal('draft_game')
        }
        else {
            showModalEbk();
            handleCancel();
        }
    };

    const onRedirect1Game = async () => {
        setGameRedirectLoader(true)
        const data = await dispatch(handleAutologinOneGame(currentUser.id,
            currentClass.id,
            {
                user_role_admin: isAdmin,
                action: 'home_game',
                role: 'teacher',
                class_info: getClassMetadata(),
                user_type,
                grade_category,
                grade_type,
                isAiPermissionEnabled
            }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth';
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
        }
        setGameRedirectLoader(false)
        handleCancel()
    }

    const onGameEdit = async (gameData) => {
        setGameEditLoader(gameData.game_id);
        const data = await dispatch(handleAutologinOneGame(currentUser.id,
            currentClass.id,
            {
                user_role_admin: isAdmin,
                action: 'edit_game',
                role: 'teacher',
                game_id: gameData.game_id,
                class_info: getClassMetadata(),
                game_type: '1game',
                user_type,
                grade_category,
                grade_type,
                isAiPermissionEnabled
            }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth';
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
        }
        setGameEditLoader(null);
        handleCancel();
    }
    
    const onGamePreview = async (gamesData) => {
        const { game_id, game_mode: gameType } = gamesData || {};
        const isMobile = window.innerWidth < 568;

        if (isMobile) {
            return showAlert(
                `${gameType} Game preview is designed for larger screens and is not supported on smaller or mobile screens.`,
                "error"
            );
        }
        let uri;
        if (sysConfig.is_local) {
            uri = `http://${window.location.hostname}:3011/preview?game_id=${game_id}`;
        } else if (configServer === 'prod') {
            uri = `https://1game.nosotrosonline.com/preview?game_id=${game_id}`;
        } else {
            uri = `https://1gamestaging.nosotrosonline.com/preview?game_id=${game_id}`;
        }

        openOnegameModal(uri);
        handleCancel();
    };
    const onGameDuplicate = async (gameData) => {
        setGameDuplicateLoader(gameData.game_id)
        const data = await dispatch(handleAutologinOneGame(currentUser.id,
            currentClass.id,
            {
                user_role_admin: isAdmin,
                action: 'duplicate_game',
                role: 'teacher',
                game_id: gameData.game_id,
                class_info: getClassMetadata(),
                user_type,
                grade_category,
                grade_type,
                isAiPermissionEnabled
            }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth';
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
        }
        setGameDuplicateLoader(null)
        handleCancel();
    }
    const onPlayConfigModalClose = () => {
        setPlayConfigModal(false);
        setStartGameLoading(false)
        setPlayConfigEnable(false);
        setSelectedGame({});
    }

    const onPlayGame = (game) => {
        let game_type = game?.game_mode;
        if (window.innerWidth < 568 && game_type=="modern") {
            showAlert(`${game_type} Game is designed for larger screens and is not supported on smaller or mobile screens.`, "error");
        }
        else {
            setPlayConfigModal(true);
            setSelectedGame(game);
            setGameUngraded(false);
            setGameGradeCategory({})
            setGameGradeType({})
            setPlayConfigEnable(false);
            handleCancel();
        }
    }
    const diable_start = useMemo(() => {
        if (isCanvasUser) {
            return !game_grade_type.value || !game_grade_category.id
        } else if (isSchoologyUser) {
            return !game_grade_category.id
        } else if (game_ungraded) {
            return false
        } else if (error) {
            return true;
        }
        return !game_grade_type.value
    }, [game_grade_category, game_grade_type, game_ungraded, currentUser, error])
    return (
      <SentryWrap>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={alertSakeBar.open}
          autoHideDuration={3000}
          onClose={closeAlert}
        >
          <Alert
            onClose={() => {
              setAlertSakeBar({ open: false, message: '' });
            }}
            severity={alertSakeBar.severity}
          >
            <strong>ALERT:</strong> {alertSakeBar.message}
          </Alert>
        </Snackbar>

        <ModalDrop
          open={playConfigModal}
          onCancel={() => {
            if (!startGameLoading) onPlayConfigModalClose();
          }}
          className={`scenarioMdlWrap ${startGameLoading ? 'modal-close-disabled' : ''}`}
          maskClosable={false}
          footer={null}
        >
          <div>
            <div className="aiGmMdlInr">
              <div className="aiMdlLbl">
                <label>{game_config_enable ? '1Game!' : 'Play game mode!'}</label>
              </div>
              {game_config_enable ? (
                <>
                  <div className="aiGmMdlInr">
                    <div
                      className="createStudyBackBtn"
                      onClick={() => {
                        if (startGameLoading) return;
                        setPlayConfigEnable(false);
                      }}
                      style={{
                        pointerEvents: startGameLoading ? 'none' : 'auto',
                        cursor: startGameLoading ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <img src={DebateLftIcon} alt="Debate" />
                    </div>
                    {!isSchoologyUser && (
                      <div
                        style={{
                          pointerEvents: startGameLoading ? 'none' : 'auto',
                          opacity: startGameLoading ? 0.5 : 1,
                        }}
                      >
                        <GradeConfig
                          label={'Choose grading system'}
                          setError={setError}
                          value={game_grade_type?.value}
                          options={grade_type}
                          onChange={(value) => {
                            setGameGradeType(value);
                            setGameUngraded(false); // Reset ungraded when a grading system is selected
                          }}
                          hasInput
                          objValue={game_grade_type}
                        />
                      </div>
                    )}
                    {isCanvasUser || isSchoologyUser ? (
                      <GradeConfig
                        label={' Choose category'}
                        setError={setError}
                        value={game_grade_category?.id}
                        hasInput={isSchoologyUser}
                        options={grade_category}
                        is_schoology={isSchoologyUser}
                        onChange={(value) => {
                          setGameGradeCategory(value);
                          setGameUngraded(false); // Reset ungraded when a category is selected
                        }}
                        objValue={game_grade_category}
                      />
                    ) : null}
                    {!isSchoologyUser && !isCanvasUser ? (
                      <div
                        className="linksSectionIcon text-dark"
                        style={{
                          opacity: startGameLoading ? 0.6 : 1,
                          pointerEvents: startGameLoading ? 'none' : 'auto',
                        }}
                      >
                        <AntCheckBox
                          checked={game_ungraded}
                          className="custom-checkbox"
                          style={{ fontSize: 16, fontWeight: '600' }}
                          onChange={() => {
                            setGameGradeType({});
                            setGameGradeCategory({});
                            setGameUngraded(!game_ungraded);
                            setError(false);
                          }}
                        >
                          <span style={{ fontSize: 16, fontWeight: 600, color: 'black' }}>
                            Ungraded
                          </span>
                        </AntCheckBox>
                      </div>
                    ) : null}
                    <AntdButton
                      disabled={diable_start}
                      type="primary"
                      shape="round"
                      size={'large'}
                      loading={startGameLoading}
                      block
                      onClick={() => {
                        setStartGameLoading(true);
                        onStartGame(selectedGame, 'grade');
                      }}
                    >
                      Play
                    </AntdButton>
                  </div>
                </>
              ) : (
                <>
                  <div className="aiMdlOvr">
                    <AnimatedLink
                      isLoading={startGameLoading}
                      onClick={() => {
                        setStartGameLoading(true);
                        onStartGame(selectedGame, 'fun');
                      }}
                    >
                      <CardSpan isLoading={startGameLoading}>
                        {startGameLoading ? <Loading size={18} /> : null} Play for fun
                      </CardSpan>
                      <CardImg src={playForFunIcon} alt="" />
                    </AnimatedLink>
                  </div>
                  <div className="aiMdlOvr">
                    <AnimatedLink
                      onClick={() => {
                        if (startGameLoading) return;
                        setPlayConfigEnable(true);
                      }}
                      style={{
                        pointerEvents: startGameLoading ? 'none' : 'auto',
                        opacity: startGameLoading ? 0.5 : 1,
                      }}
                    >
                      <CardSpan isLoading={startGameLoading}>
                        <CardLabel>
                          {' '}
                          {redirectLoader === 'ai' ? <Loading size={18} /> : null} Play for grade
                        </CardLabel>
                      </CardSpan>
                      <CardImg src={playForGradeIcon} alt="" />
                    </AnimatedLink>
                  </div>
                </>
              )}
            </div>
          </div>
        </ModalDrop>
        <ModalTest
          open={aiModal || modalVisible}
          onClose={() => handleCancel()}
          // className={"gameOneMdl"}
          closeIcon={<CloseOutlined />}
        >
          <ModalContentDelete style={{ position: 'relative' }}>
            <IconButton
              onClick={() => handleCancel()}
              style={{ position: 'absolute', top: 0, right: 0 }}
            >
              <Close color="secondary" />
            </IconButton>
            <div>
              <div className="createBtnGame">
                <ButtonContainers className="btnGameGrpPadding15">
                  {!isAdmin && (
                    <Badge
                      overlap="rectangular"
                      badgeContent={
                        pageLearningModuleCountGamesAdmin?.length > 0
                          ? pageLearningModuleCountGamesAdmin?.length
                          : undefined
                      }
                      // badgeContent={pageLearningModuleCount?.bingo_admin > 0 ? pageLearningModuleCount?.bingo_admin : '0'}
                      // badgeContent={'0'}
                      color="info"
                      variant="standard"
                    >
                      <Button
                        variant="outlined"
                        color={'primary'}
                        onClick={() => {
                          showModal(1);
                        }}
                        // style={currentSection === 1 ? { background: 'teal', color: 'white', fontWeight: '700' } : {}}
                        // className='BtnSelectedoneGame'
                        className={`BtnSelectedoneGame ${currentSection === 1 ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneGameFocus'}`}
                      >
                        One Way Created
                      </Button>
                    </Badge>
                  )}
                  <Badge
                    overlap="rectangular"
                    // badgeContent={pageLearningModuleCount?.bingo_admin > 0 ? pageLearningModuleCount?.bingo_admin : '0'}
                    badgeContent={
                      pageLearningModuleCountGames?.length > 0
                        ? pageLearningModuleCountGames?.length
                        : undefined
                    }
                    color="info"
                    variant="standard"
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        showModal('my_game');
                      }}
                      className={`BtnSelectedoneGame ${currentSection === 'my_game' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneGameFocus'}`}
                    >
                      My Games
                    </Button>
                  </Badge>

                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      showModal('all_teachers');
                    }}
                    // style={currentSection === "all_teachers" ? { boxShadow: `3px 8px 20px 6px #08182e` } : {}}
                    className={`BtnSelectedoneGame ${currentSection === 'all_teachers' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneGameFocus'}`}
                    // className='BtnSelectedoneGame'
                  >
                    {' '}
                    Teacher Created
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      showModal('draft_game');
                    }}
                    className={`BtnSelectedoneGame ${currentSection === 'draft_game' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneGameFocus'}`}
                  >
                    Draft
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      showModalEbk();
                      handleCancel();
                    }}
                    // style={currentSection === 3 ? {} : {}}
                    // className='BtnSelectedoneGame'
                    className={`BtnSelectedoneGame ${currentSection === '3' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneGameFocus'}`}
                  >
                    Create 1Game
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      onRedirect1Game();
                    }}
                    // style={currentSection === "all_teachers" ? { boxShadow: `3px 8px 20px 6px #08182e` } : {}}
                    className={`BtnSelectedoneGame ${currentSection === '1Game' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneGameFocus'}`}
                    // className='BtnSelectedoneGame'
                  >
                    {gameRedirectLoader ? <Loading size={12} white /> : null} 1Game Homepage
                  </Button>
                  <div>
                    <div className="studyDropDwnCard studyMobileDropDwn">
                      <select
                        value={gameTypeSelect}
                        onChange={(e) => {
                          setGameTypeSelect(e.target.value);
                          if (currentSection === 'my_game') {
                            setCurrentSection('my_game');
                          }
                          if (currentSection === 1) {
                            //admin
                            setCurrentSection(1);
                          }
                          if (currentSection === 'draft_game') {
                            //draft
                            setCurrentSection('draft_game');
                          }
                          if (currentSection === 'all_teachers') {
                            //teacherwide
                            setCurrentSection('all_teachers');
                          }
                        }}
                        style={{ width: 115 }}
                      >
                        <option value={'all'} variant="outlined" color={'primary'}>
                          All
                        </option>
                        <option value={'classic'} variant="outlined" color="primary">
                          Classic
                        </option>
                        <option value={'modern'} variant="outlined" color="primary">
                          Modern
                        </option>
                      </select>
                    </div>
                  </div>
                  <DemoPreview video_id={'1game-demo'} wrapperStyle={{}} />
                </ButtonContainers>
              </div>
              <div className="mb-8 showInMobile mobileStudyFilterSec">
                <Select
                  labelId="simple-select-label"
                  id="simple-select"
                  // value={selectedOption}
                  style={{
                    backgroundColor: 'white',
                    width: '100%',
                    borderRadius: 8,
                    padding: '5px 12px',
                    marginTop: 15,
                  }}
                  onChange={(e) => {
                    handleChange(e.target.value);
                  }}
                  value={currentSection}
                >
                  <MenuItem value="1">One Way Created</MenuItem>
                  <MenuItem value="my_game">My 1Game's</MenuItem>
                  <MenuItem value="draft_game"> Draft</MenuItem>
                  <MenuItem value="all_teachers">Teachers Nationwide</MenuItem>
                  <MenuItem value="Create 1games">Create 1Game</MenuItem>
                  <MenuItem value="Game_Homepage"> 1Game Homepage</MenuItem>
                </Select>

                <div className="previwMobile">
                  <div className="studyDropDwnCard studyMobileDropDwn">
                    <select
                      value={gameTypeSelect}
                      onChange={(e) => {
                        setGameTypeSelect(e.target.value);
                        if (currentSection === 'my_game') {
                          setCurrentSection('my_game');
                        }
                        if (currentSection === 1) {
                          //admin
                          setCurrentSection(1);
                        }
                        if (currentSection === 'draft_game') {
                          //draft
                          setCurrentSection('draft_game');
                        }
                        if (currentSection === 'all_teachers') {
                          //teacherwide
                          setCurrentSection('all_teachers');
                        }
                      }}
                      style={{ width: 115 }}
                    >
                      <option value={'all'} variant="outlined" color={'primary'}>
                        All
                      </option>
                      <option value={'classic'} variant="outlined" color="primary">
                        Classic
                      </option>
                      <option value={'modern'} variant="outlined" color="primary">
                        Modern
                      </option>
                    </select>
                  </div>
                  <DemoPreview
                    video_id={'1game-demo'}
                    wrapperStyle={{}}
                    style={{ marginTop: '10px', marginLeft: '10px' }}
                  />
                </div>
              </div>
              {currentSection === 1 && (
                <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                  <div className="gmCollection">
                    <AdminGame
                      gameType={gameTypeSelect}
                      showDrawer={showDrawer}
                      setCurrentSection={setCurrentSection}
                      bookId={chapter}
                      pageId={page}
                      userId={currentUser?.id}
                      gameInitLoader={gameInitLoader}
                      startGame={(e) => {
                        onPlayGame(e);
                      }}
                      previewGame={onGamePreview}
                      gameDuplicateLoader={gameDuplicateLoader}
                      onDuplicateGame={(e) => {
                        onGameDuplicate(e);
                      }}
                      newMaskId={newMaskId}
                      backToLabelStory={backToLabelStory}
                      resource={resource}
                    />
                  </div>
                </div>
              )}

              {currentSection === 'my_game' && (
                <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                  <div className="gmCollection">
                    <Mygame
                      gameType={gameTypeSelect}
                      showDrawer={showDrawer}
                      setCurrentSection={setCurrentSection}
                      bookId={chapter}
                      pageId={page}
                      userId={currentUser?.id}
                      onEditGame={(gameData) => {
                        onGameEdit(gameData);
                      }}
                      onGameSelect={(val) => {
                        setActiveGame(val);
                      }}
                      gameInitLoader={gameInitLoader}
                      gameEditLoader={gameEditLoader}
                      startGame={(e) => {
                        onPlayGame(e);
                      }}
                      previewGame={onGamePreview}
                      newMaskId={newMaskId}
                      backToLabelStory={backToLabelStory}
                      resource={resource}
                    />
                  </div>
                </div>
              )}

              {currentSection === 'draft_game' && (
                <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                  <div className="gmCollection">
                    <DraftGame
                      gameType={gameTypeSelect}
                      showDrawer={showDrawer}
                      setCurrentSection={setCurrentSection}
                      bookId={chapter}
                      pageId={page}
                      userId={currentUser?.id}
                      onEditGame={(gameData) => {
                        onGameEdit(gameData);
                      }}
                      gameInitLoader={gameInitLoader}
                      gameEditLoader={gameEditLoader}
                      startGame={(e) => {
                        onPlayGame(e);
                      }}
                      previewGame={onGamePreview}
                      newMaskId={newMaskId}
                    />
                  </div>
                </div>
              )}
              {currentSection === 'all_teachers' && (
                <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                  <div className="gmCollection">
                    <AllTeachers
                      gameType={gameTypeSelect}
                      showDrawer={showDrawer}
                      setCurrentSection={setCurrentSection}
                      bookId={chapter}
                      pageId={page}
                      userId={currentUser?.id}
                      gameInitLoader={gameInitLoader}
                      startGame={(e) => {
                        onPlayGame(e);
                      }}
                      previewGame={onGamePreview}
                      onDuplicateGame={(e) => {
                        onGameDuplicate(e);
                      }}
                      gameDuplicateLoader={gameDuplicateLoader}
                      newMaskId={newMaskId}
                    />
                  </div>
                </div>
              )}

              {currentSection === 3 && (
                <div className="writeTpcUpr">
                  <div className="newTxtModal">
                    <span>Name your 1Game:</span>
                    <Input placeholder="" />
                  </div>
                  <div className="catogryAndSystem">
                    <div className="subCatogryAndSystem">
                      <div className="allCategorySection">
                        <div>
                          <div
                            className={`selectCategoryBox ${isOpen ? 'open' : ''}`}
                            onClick={() => setIsOpen(!isOpen)}
                          >
                            {selectedOption || 'Choose category'}
                            <div>
                              <DownOutlined />
                            </div>
                          </div>
                          {isOpen && (
                            <div className="allOptions">
                              <div
                                className="option"
                                onClick={() => handleSelectChange('Homework')}
                              >
                                <p>Homework</p>
                                <p>20%</p>
                              </div>
                              <div
                                className="option"
                                onClick={() => handleSelectChange('Participation')}
                              >
                                <p>Participation</p>
                                <p>20%</p>
                              </div>
                              <div className="option" onClick={() => handleSelectChange('Quiz')}>
                                <p>Quiz</p>
                                <p>20%</p>
                              </div>
                              <div
                                className="option"
                                onClick={() => handleSelectChange('Classwork')}
                              >
                                <p>Classwork</p>
                                <p>20%</p>
                              </div>
                              <div className="option" onClick={() => handleSelectChange('Exam')}>
                                <p>Exam</p>
                                <p>20%</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="allCategorySection">
                        <div>
                          <div
                            className={`gradingCategoryBox ${gradingIsOpen ? 'open' : ''}`}
                            onClick={() => setGradingIsOpen(!gradingIsOpen)}
                          >
                            {selectedOptions || 'Grading System'}
                            <div>
                              <DownOutlined />
                            </div>
                          </div>
                          {gradingIsOpen && (
                            <div className="allOptionsSection">
                              <div className="gardingCheckbox">
                                <div
                                  className="option"
                                  onClick={() => handleSelectGrading('Points')}
                                >
                                  <p>Points</p>
                                </div>
                                <Input placeholder="" />
                              </div>
                              <div
                                className="option"
                                onClick={() => handleSelectGrading('Percentage')}
                              >
                                <p>Percentage</p>
                              </div>
                              <div
                                className="option"
                                onClick={() => handleSelectGrading('Letters')}
                              >
                                <p>Letters</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </ModalContentDelete>
        </ModalTest>

        <Drawer
          placement="right"
          closable={true}
          onClose={onClose}
          open={visible}
          width="100%"
          zIndex={9999}
          className="gameDevicemMain"
        >
          <Row className="gameOnDevice">
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <div className="gameDeviceLeft">
                <img src={IGameModalImgDeck} alt="" />
              </div>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <div className="gameDeviceRght">
                <div className="gameLogo">
                  <img src={IGameLogo} alt="" />
                </div>
              </div>
            </Col>
          </Row>
        </Drawer>
        <ModalTest
          open={createConfigModal}
          onClose={onAIPagesClose}
          style={{ height: '100%', width: '100%' }}
        >
          <ModalContent style={{ width: '60vw', minHeight: 'auto' }}>
            <Row style={{ justifyContent: 'space-between' }}>
              <IconButton onClick={() => onAIPagesClose()} style={{ padding: 0, marginRight: 10 }}>
                <Close color="secondary" />
              </IconButton>
            </Row>
            <ModalConfigArea style={{ overflow: 'visible' }}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginTop: 12 }}
              >
                <InputLabel id="pages-label">Select Pages (max 10)</InputLabel>
                <Select
                  labelId="pages-label"
                  multiple
                  value={
                    typeof config.pages === 'string'
                      ? config.pages
                          .split(',')
                          .filter((p) => p.trim() !== '')
                          .map(Number)
                      : []
                  }
                  onChange={(e) => {
                    const selectedValues = e.target.value;
                    const previousSelected =
                      typeof config.pages === 'string' ? config.pages.split(',').map(Number) : [];
                    if (
                      selectedValues.length > 10 &&
                      selectedValues.length > previousSelected.length
                    ) {
                      showAlert('You can select a maximum of 10 pages.', 'warning');
                      return;
                    }
                    const value = selectedValues.join(',');
                    setConfig((k) => ({ ...k, pages: value }));
                    setError(null);
                  }}
                  input={<OutlinedInput label="Select Pages (max 10)" />}
                  renderValue={(selected) => (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {selected.map((id) => {
                        const match = pages.find((p) => p.pageId == id);
                        return <Chip key={id} label={match?.NumberMasked || id} />;
                      })}
                    </div>
                  )}
                >
                  {pages.map((page) => (
                    <MenuItem key={page.pageId} value={parseInt(page.pageId)}>
                      <RenderIfVisible defaultHeight={24} stayRendered={true} visibleOffset={500}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4,
                          }}
                        >
                          <Checkbox
                            checked={
                              typeof config.pages === 'string'
                                ? config.pages
                                    .split(',')
                                    .filter((p) => p.trim() !== '')
                                    .includes(page.pageId?.toString?.())
                                : false
                            }
                          />
                          <ListItemText primary={page.NumberMasked} />
                        </div>
                      </RenderIfVisible>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </ModalConfigArea>
            {error ? <CustomFormHelperText>{error}</CustomFormHelperText> : null}
            <Row gutter={[24, 24]} style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}>
              <Button
                fullWidth
                onClick={() => {
                  onAiContentCreation();
                }}
                color="primary"
                variant="contained"
                disabled={
                  createLoader ||
                  !(
                    typeof config.pages === 'string' &&
                    config.pages.split(',').filter((p) => p.trim() !== '').length > 0
                  )
                }
                startIcon={createLoader ? <Loading white size={14} /> : null}
              >
                Generate
              </Button>
            </Row>
          </ModalContent>
        </ModalTest>
        <div className="vocOrGame addOneImgBtnUpr 111" ref={inputRef}>
          {!isAdmin ? (
            <Badge
              overlap="rectangular"
              badgeContent={
                pageLearningModuleCountGamesAdmin?.length > 0 ||
                pageLearningModuleCountGames?.length > 0
                  ? '✓'
                  : undefined
              }
              color="success"
              variant="standard"
              sx={{ width: '100%' }}
            >
              <Button
                className="addOneImg addOneImgBtn"
                onClick={() => {
                  if (checkPopUpAtOnce()) return;
                  if (handleForDistrictAdmin()) return;
                  showModal(isAdmin ? 'my_game' : 1);
                  updatePopUpAtOnce(true);
                }}
              >
                <img
                  src={OneGameUpdated}
                  alt="1Game"
                  title="1Game"
                />
              </Button>
            </Badge>
          ) : (
            <Button
              className="addOneImg addOneImgBtn"
              onClick={() => {
                if (checkPopUpAtOnce()) return;
                if (handleForDistrictAdmin()) return;
                showModal(isAdmin ? 'my_game' : 1);
                updatePopUpAtOnce(true);
              }}
            >
              <img
                src={OneGameUpdated}
                alt="1Game"
                title="1Game"
              />
            </Button>
          )}
        </div>

        <ModalDrop
          open={gameVisibleEbk}
          onCancel={handleCancelEbk}
          className={`scenarioMdlWrap    ${currentScenarioEbk >= 6 && currentScenarioEbk < 9 ? 'modalNextSix' : currentScenarioEbk >= 3 ? 'gmScenarioSecond' : ''}`}
          maskClosable={false}
        >
          <div>
            {currentScenarioEbk === 1 && (
              <div className="aiGmMdl">
                <div
                  className="createStudyBackBtn"
                  onClick={() => {
                    setCurrentScenarioEbk(2);
                  }}
                >
                  <img src={DebateLftIcon} alt="Debate" />
                </div>
                <div className="aiMdlLbl">
                  <label>Create your 1Game!</label> <AIUsageInfo />{' '}
                </div>
                <div className="aiGmMdlInr">
                  <div className="aiMdlOvr">
                    <a onClick={() => (btnClicked ? null : handleRedirectOnegame('blank'))}>
                      <span>
                        {redirectLoader === 'blank' ? <Loading size={18} /> : null} Blank template
                      </span>{' '}
                      <img src={studyBlankTemplate} alt="" />
                    </a>
                  </div>
                  <div className="aiMdlOvr">
                    <a onClick={handleAIGenerateFromBookSection}>
                      <span>
                        <label>
                          {' '}
                          {redirectLoader === 'ai_content' ? <Loading size={18} /> : null} AI
                          Generator utilizing
                        </label>{' '}
                        this book section
                      </span>{' '}
                      <img src={AiGeneratedBook} alt="" />
                    </a>
                  </div>
                  <div className="aiMdlOvr">
                    <a onClick={handleAIGenerateFromMyOwnTopics}>
                      <span>
                        <label>
                          {' '}
                          {redirectLoader === 'ai' ? <Loading size={18} /> : null} AI Generator
                          using
                        </label>{' '}
                        my own topics
                      </span>{' '}
                      <img src={AiGeneratedTopic} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            )}
            {currentScenarioEbk === 2 && (
              <div className="aiGmMdl">
                <div className="aiMdlLbl">
                  <label>Choose your mode!</label>
                </div>
                <div className="aiGmMdlInr">
                  <div className="aiMdlOvr">
                    <a onClick={() => handleMode('classic')}>
                      <span> Classic</span> <img src={ClassicGames} alt="" />
                    </a>
                  </div>
                  <div className="aiMdlOvr">
                    <a onClick={() => handleMode('modern')}>
                      <span> Modern</span> <img src={ModernGame} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </ModalDrop>
      </SentryWrap>
    );
};

export default OnegameModals;
